// React
import React from 'react';
import { Row, Col, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';

export const ModalBalanceHasReduced = ({ isOpen, toggle, handleSubmit }) => {
  return (
    <React.Fragment>
      <Modal
        isOpen={isOpen}
        toggle={() => toggle()}
        centered
        zIndex={10000}
        size={'lg'}
        id="staticBackdrop"
      >
        <ModalHeader toggle={() => toggle()}>
          Você está confirmando com um valor menor do que o previsto.
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div className="mb-3">
                <Label htmlFor="scheduleType" className="form-label">
                  Deseja gerar um lançamento com resíduo deste título?
                </Label>
                <div className="d-block justify-content-between align-items-center mt-3">
                  <div className="hstack gap-2 justify-content-center">
                    <button
                      className="btn btn-primary"
                      onClick={() => handleSubmit(true)}
                    >
                      Sim
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={() => handleSubmit(false)}
                    >
                      Não
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
